import { render, staticRenderFns } from "./Budgets2.vue?vue&type=template&id=5886e63e&scoped=true&"
import script from "./Budgets2.vue?vue&type=script&lang=js&"
export * from "./Budgets2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5886e63e",
  null
  
)

export default component.exports